import {
  autoserialize,
  autoserializeAs, deserialize, deserializeAs,
} from 'cerialize';


export class CutBatchData {
  @autoserialize id!: string;
  @autoserialize cut!: string;
  @autoserialize batch!: string;
  @autoserializeAs("x_values") xValues!: Array<number>;
  @autoserializeAs("y_values") yValues!: Array<number>;
  @autoserializeAs("date_acquired") dateAcquired!: string;

  get dataset(): Array<any> {
    return this.xValues
      .map((value: number, index: number) => {
        return [value, this.yValues[index]];
      });
  }
}

export type CutProfileDeviationStatus =
  | 'ok'
  | 'same_batch'
  | 'missing_profile'
  | 'invalid_profile'
  | 'flat_reference';

export class CutProfileDeviation {
  @deserializeAs('cut_id') cutId!: string;

  @deserialize value!: number | null;

  @deserialize rmse!: number | null;

  @deserializeAs('maximum_deviation') maximumDeviation!: number | null;

  @deserializeAs('compared_point_count') comparedPointCount!: number;

  @deserialize status!: CutProfileDeviationStatus;
}

export class Cut {
  kind: string = 'cut';
  checked: boolean = true;
  @autoserialize id!: string;
  @autoserialize name!: string;
  @autoserialize author!: string;
  @autoserialize point1!: Array<number>;
  @autoserialize point2!: Array<number>;
  @autoserialize slope: Array<Array<number>> | null = null;
  @deserialize center!: Array<number>;
  @deserializeAs('camera_direction') cameraDirection!: Array<number>;
  @deserialize length!: number;
  @deserializeAs('is_shared') isShared!: boolean;
  @deserializeAs(CutProfileDeviation, 'profile_deviation') profileDeviation: CutProfileDeviation | null = null;
  show: boolean;

  constructor() {
    this.show = true;
  }
}

